export const FileMime = {
    "image/jpeg": "image/jpeg",
    "image/png": "image/png",
    "image/webp": "image/webp",
    "video/mp4": "video/mp4",
    "audio/mpeg": "audio/mpeg",
} as const;

export type FileMime = keyof typeof FileMime